// Unified document schema for all order types
// Reconciles eFiling-specific fields from filing.schema.ts with generic documents
import { z } from 'zod/v4';
import { EFilingDocumentTypeRefSchema, EFilingDocumentTitleRefSchema, } from '../efiling/filing.schema.js';
// ---------------------------------------------------------------------------
// Document category
// ---------------------------------------------------------------------------
export const DocumentCategorySchema = z.enum([
    'filing-document',
    'supporting-document',
    'proof-of-service',
    'exhibit',
    'declaration',
    'summons',
    'subpoena',
    'writ',
    'court-order',
    'correspondence',
    'other',
    'conformed-copy',
]);
// ---------------------------------------------------------------------------
// Upload metadata (used when uploading documents)
// ---------------------------------------------------------------------------
export const DocumentUploadMetadataSchema = z.object({
    fileName: z.string(),
    mimeType: z.string(),
    size: z.number().max(50 * 1024 * 1024), // 50MB max
    category: DocumentCategorySchema.optional(),
    description: z.string().optional(),
});
// ---------------------------------------------------------------------------
// Order document (stored record — includes both generic and eFiling fields)
// ---------------------------------------------------------------------------
export const OrderDocumentSchema = z.object({
    id: z.string().uuid(),
    orderId: z.string().uuid(),
    fileName: z.string(),
    originalFileName: z.string(),
    mimeType: z.string(),
    size: z.number(),
    gcsPath: z.string().optional(),
    downloadUrl: z.string().url().optional(),
    category: DocumentCategorySchema.optional(),
    description: z.string().optional(),
    pageCount: z.number().optional(),
    uploadedAt: z.string().datetime(),
    uploadedByUserId: z.string().uuid(),
    // eFiling-specific fields (populated when order type is e-filing)
    efileKey: z.string().optional(),
    documentType: EFilingDocumentTypeRefSchema.optional(),
    documentTitle: EFilingDocumentTitleRefSchema.optional(),
    isLeadDocument: z.boolean().optional(),
    metadataValues: z.record(z.string(), z.unknown()).optional(),
    securityLevel: z.string().optional(),
    isPrivate: z.boolean().optional(),
});
